import { render, staticRenderFns } from "./SortableCardGrid.vue?vue&type=template&id=b7c36b18&"
import script from "./SortableCardGrid.vue?vue&type=script&lang=js&"
export * from "./SortableCardGrid.vue?vue&type=script&lang=js&"
import style0 from "./SortableCardGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports